import classNames from 'classnames'
import { PropsWithChildren } from 'react'
import { WebQuote } from '../../../../server/utils/web/buildWebOffer'
import { formatCentsAmountEuro } from '../../../../utils/formatCentsAmount'
import Svg from '../../../Svg'

type Props = {
  quote: WebQuote
  onClick: () => void
  isOpen: boolean
  isDevis?: boolean
}

export function WebProductCard(props: PropsWithChildren<Props>) {
  const background = props.isOpen ? props.quote.product.background.opened : props.quote.product.background.closed
  // previous code
  // const productStyle = props.isDevis
  // ? 'min-w-[329px] sm:min-w-[450px] md:min-w-[620px] lg:min-w-[890px] xl:min-w-[500px]'
  // : 'w-full sm:min-w-[320px] lg:min-w-[500px]'
  const productStyle = props.isDevis
    ? 'min-w-[329px] sm:min-w-[450px] md:min-w-[620px] lg:min-w-[890px] xl:min-w-[500px]'
    : 'w-full sm:min-w-[300px] lg:min-w-[500px]'
  const waveStyle = props.isDevis ? 'md:bg-[length:38%] lg:bg-[length:55%] xl:bg-[length:100%]' : 'lg:bg-[length:90%]'

  return (
    <div className={classNames('bg-white ', 'shadow-lg', 'rounded-2xl', productStyle)} role="button">
      <div
        className={classNames(
          'flex items-center px-5 lg:px-7 h-28 lg:h-52',
          'bg-no-repeat bg-right-bottom',
          'bg-origin-padding',
          'bg-[length:80%]',
          waveStyle,
          { 'rounded-xl': !props.isOpen }
        )}
        style={{
          backgroundImage: `url(${background.src})`,
        }}
        onClick={props.onClick}
      >
        <div className="mr-3 lg:mr-4 w-16 lg:w-24">
          <Svg alt={`Icone ${props.quote.product.label}`} src={props.quote.product.icon} width={100} height={100} />
        </div>

        <div className="flex flex-col space-y-2.5 lg:space-y-4">
          <div className="font-bold text-[19px] lg:text-[30px]">{props.quote.product.label}</div>

          <div className="text-[15px] lg:text-3xl lg:text-2xl">
            {formatCentsAmountEuro(props.quote.persons[0].price.full)}/mois
          </div>
        </div>
      </div>
      {props.isOpen && <div className="pb-4">{props.children}</div>}
    </div>
  )
}
